// extracted by mini-css-extract-plugin
module.exports = {"rolloverTakeActionButton":"checkRollover_rolloverTakeActionButton__2Wrbe"};